<template >
  <div class="deviceBind">
   <el-card class="box-card">
    <div slot="header" class="clearfix">
      <div style="float:left">
        <el-button type="danger" v-if="userType==0||userType==1" @click="confirmRemove()">回收设备</el-button>
        <el-button type="success" @click="allotDevice" v-if="userType!=4">分配设备</el-button>
        <el-button type="success" @click="openAllotRightPop('wx')" v-if="userType!=4">分配公众号</el-button>
        <el-button type="success" @click="openAllotRightPop('video')" v-if="userType!=4">分配视频</el-button>
        <el-button type="success" @click="openAllotRightPop('pic')" v-if="userType!=4">分配广告</el-button>
        <el-button type="success" @click="openAllotRightPop('picFirst')" v-if="userType!=4">上分屏广告</el-button>
        <el-button type="success" @click="openAllotRightPop('picFu')" v-if="userType!=4">副屏广告</el-button>

      
        <!-- <el-button type="success" @click="openAllotRightPop('sale')" v-if="userType==0">分配销售</el-button> -->
        <el-button type="success" @click="openAllotRightPop('bussiness')" v-if="userType!=4">分配商户</el-button>
        <el-button type="success" @click="openAllotRightPop('operate')" v-if="userType==0||userType==2||userType==1">分配运营</el-button>

       

         <el-button type="success" @click="seeOnlineDevice">{{onlineDevice==0?"全部设备":onlineDevice==1?"在线设备":"离线设备"}}</el-button>

        <el-button type="success" @click="confirmJoinAntMerchant('')" v-if="getAntMechant()==true">机具入驻</el-button>
        <!--<el-button type="primary" @click="popEditPrice(0)" v-if="userType==2">修改价格</el-button>-->
        <!-- <div style="display: inline-block;margin-left:10px;">
          <span style="vertical-align: middle;color: #20a0ff;">是否接收平台广告?</span>
          <el-switch
          style="display: inline-block;"
          v-model="value4"
          active-value='1'
          inactive-value='0'
          @change="changePlatformStatus">
        </el-switch>
        </div>  -->
      </div>
      <span style="line-height: 36px;">已激活设备</span>
      <div style="float:right">
        <el-input placeholder="编号/昵称/地址" v-model="searchValue" @keyup.enter.native="queryDevicByKeyword">
          <el-select v-model="searchSelect" slot="prepend" placeholder="请选择">
            <el-option label="设备编号" value="0"></el-option>
            <el-option label="设备昵称" value="1"></el-option>
            <el-option label="设备地址" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="search" @click="queryDevicByKeyword"></el-button>
        </el-input>
      </div>
    </div>
    <div class="bindTable">
      <el-table
      ref="deviceSelect"
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      height="520"
      style="width: 100%"
      @selection-change="deviceSelectionChange">
      <el-table-column
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column
        prop="num"
        header-align="center"
        min-width="95"
        label="设备编号">
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        min-width="200"
        label="设备昵称">
      </el-table-column>
    <!--  <el-table-column
        prop="user_type"
        header-align="center"
        min-width="95"
        label="账号类型">
      </el-table-column>-->
      <el-table-column
        prop="owner"
        header-align="center"
        min-width="95"
        label="设备所属">
      </el-table-column>
      <el-table-column
        prop="payStatus"
        v-if="accessToken!='ac7e0e532b30a5eb4e0bddf737b40e16' && userType!=4"
        header-align="center"
        min-width="120"
        label="流程"
        >
        <template scope="scope">
          <el-popover
            ref="popoverPayStatus1"
            placement="top-start"
            width="200"
            trigger="hover">
            <h4 style="text-align: center;">取货流程{{scope.row.payStatus}}</h4>
            <p>{{payStatusDes(scope.row.payStatus)}}</p>
          </el-popover>
          <span style="padding: 5px 10px;" v-popover:popoverPayStatus1>{{scope.row.payStatus}}</span>
          <i class="el-icon-edit" v-show="getAuthorityNoFlow()==false"
          @click="popEditP(scope.row.num,scope.row.payStatus,scope.row.payPoints,scope.row.payCharge, scope.row.extendInfo, scope.row.bGetUserInfo)"></i>
        </template>
      </el-table-column>

      <el-table-column
        prop=""
        v-if="accessToken=='ac7e0e532b30a5eb4e0bddf737b40e16'"
        header-align="center"
        min-width="120"
        label="支付参数">
        <template scope="scope">
          <span style="padding: 5px 10px;">配置</span>
          <i class="el-icon-edit" @click="popEditParam(scope.row.num)"></i>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="payStatus"
        header-align="center"
        min-width="120"
        v-if="userType == 2"
        label="价格">
        <template scope="scope">
          <span style="padding: 5px 10px;">{{scope.row.payCharge}}</span>
          <i class="el-icon-edit" @click="popEditPrice(scope.row.num,scope.row.payCharge)"></i>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="spase"
        header-align="center"
        min-width="95"
        label="所在场景">
      </el-table-column>
      <el-table-column
        prop="address"
        header-align="center"
        min-width="250"
        label="设备地址">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        width="80"
        label="状态">
        <template scope="scope">
        <el-tag :type="scope.row.status === '离线' ? 'danger' : 'success'"
        close-transition>{{scope.row.status}}</el-tag>

        <el-tag type='danger'
        v-if ="scope.row.badTxt != ''"
        close-transition>{{scope.row.badTxt}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="pager"
        header-align="center"
        width="100"
        label="货物量">
        <template scope="scope">
        <span v-if="scope.row.pager/scope.row.paperVolume > 0.75"
        style="color:#13CE66">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.50"
        style="color:#b8ce13">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.25"
        style="color:#F7BA2A">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else
        style="color:#FF4949">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="see"
        header-align="center"
        min-width="240"
        label="查看" v-if="userType!=4">
        <template scope="scope">


            <el-button
                @click="seeNext('ad', scope.row.num)"
                type="text" size="small">
                广告
            </el-button>
            <el-button
                @click="seeNext('firstAd', scope.row.num)"
                type="text" size="small">
                上分屏广告
            </el-button>
            <el-button
                @click="seeNext('fuAd', scope.row.num)"
                type="text" size="small">
                副屏广告
            </el-button>

            <el-button
                @click="seeNext('weixin', scope.row.num)"
                type="text" size="small">公众号</el-button>
            <el-button
              @click="seeNext('deviceInfo', scope.row.num)"
              type="text" size="small">设备信息</el-button>
            <el-button
              @click="seeNext('pageRecord', scope.row.num)"
              type="text" size="small">补货记录</el-button>
              <el-button
              @click="seeNext('outPaperRecord', scope.row.num, scope.row.uuid)"
              type="text" size="small" v-if="userType==0">出货记录</el-button>
              <el-button
              @click="popUpdateDeviceCargoLane(scope.row.uuid, 0)"
              type="text" size="small" v-if="scope.row.laneInfoStr">切换单层</el-button>
              <el-button
              @click="popUpdateDeviceCargoLane(scope.row.uuid, 1)"
              type="text" size="small" v-else>切换双层</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  <po-allot-device v-if="allotDeviceShow" :add-show="show" :allot-params="multipleSelection" :device-id="deviceId" @closeAllotAccount="closeAllot"></po-allot-device>
  <pu-allot-pop-right
    v-if="allotShow"
    :allot-pop-right-ok="allotPopRightOk"
    :device-list="deviceSelect"
    :allot-type = 'allotType'
    @closeAllotRightPop="closeAllotRightPop">
  </pu-allot-pop-right>
  <pu-see-pop-right
    v-if="seeShow"
    :see-pop-right-ok="seePopRightOk"
    :device-code="deviceCode"
    :see-type = 'seeType'
    :the-uuid = 'uuid'
    @closeSeeRightPop="closeSeeRightPop">
  </pu-see-pop-right>
  <pu-edit-pop
    :add-show="myEditPopShow"
    :edit-dvce-code="deviceCode"
    :edit-status="eStatus"
    :edit-points="ePoints"
    :edit-price="ePrice"
    :edit-extend="extendInfo"
    :edit-get-userinfo="bGetUserInfo"
    @closeEditPoint="closeEditP"></pu-edit-pop>
  <pu-edit-pop-param
      :add-show="myEditPopShowParam"
      :edit-dvce-code="deviceCode"
      @closeEditPointParam="closeEditParam"></pu-edit-pop-param>
    <pu-edit-price
    :add-show="myEditPriceShow"
    :edit-dvce-code="deviceCode"
    :edit-price="ePrice"
    @closeEditPrice="closeEditPrice"></pu-edit-price>
  </div>
</template>
<script>
    import puAllotPopRight from '@/page/deviceMgr/allotPopRight'
    import puSeePopRight from '@/page/deviceMgr/seePopRight'
    import puEditPop from '@/page/deviceMgr/editPoint'
    import puEditPopParam from '@/page/deviceMgr/editParam'
    import puEditPrice from '@/page/deviceMgr/editPrice'
    import poAllotDevice from '@/page/deviceMgr/allotDevice'
    import $axios from '../../https/config'
    import {isNull,getAuthority} from '../../js/tool'
    import store from '../../vuex/store'

    export default {
      data () {
        return {
          deviceData: [],
          value4: 1,
          myEditPopShow: false,
          myEditPopShowParam: false,
          myEditPriceShow: false,
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          userType: this.$store.state.userType,
          table_loading: false,
          spaceTypeList: '',
          allotPopRightOk: false,
          multipleSelection: '',
          deviceSelect: [],
          allotType: '',
          seePopRightOk: false,
          deviceCode: '',
          eStatus: '',
          ePoints: '',
          ePrice: '',
          seeType: '',
          allotShow: false,
          seeShow: false,
          searchValue: '',
          searchSelect: '0',
          deviceId: '',
          uuid: '',
          laneInfoStr:'',
          accessToken:'',
          extendInfo:{},
          bGetUserInfo: true,
          allotDeviceShow: false,
          show:false,
          onlineDevice:0,

        }
      },
      created: function () {
        this.pageNo = 1
        this.getSpaseTypeList(),
        this.accessToken = sessionStorage.getItem('lbz_accessToken')
      },
      methods: {
        getBadStatus:function(isBad){
          console.log("isBad="+isBad);
          if (isBad==0){
            return "";
          }else if(isBad==1){
            return "无货";
          }else if(isBad==2){
            return "无黑标";
          }else if(isBad==3){
            return "切刀故障";
          }else if(isBad==4){
            return "商品卡住";
          }else if(isBad==99){
            return "驱动板超时";
          }
        },
        seeOnlineDevice(){
          if(this.onlineDevice==0){
            this.onlineDevice =1 ;
          }else if(this.onlineDevice==1){
            this.onlineDevice =2 ;
          }else {
            this.onlineDevice =0 ;
          }
         // this.onlineDevice = (this.onlineDevice==0?1:0)
          console.log("onlineDevice="+this.onlineDevice);
          this.queryDeviceList(this.pageNo, this.pageSize, '')


        },
        getAuthorityNoFlow () {
          return getAuthority("noFlow")
        },
        getAntMechant () {
          return getAuthority("antMerchant")
        },
        confirmJoinAntMerchant () {
          var that = this
          if (that.multipleSelection.length === 0) {
            that.$alert('请选择要入驻的设备', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return false
          }
          that.$confirm('您已选择设备：' + that.multipleSelection, '是否入驻选中的设备', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var params = {
              deviceId: that.deviceId
            }
            $axios.get('/device/joinAntMerchant', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                //that.queryDeviceList(that.pageNo, that.pageSize, '')
                that.$message({
                  type: 'success',
                  message: '入驻成功!'
                })
              } else {
                that.$message({
                  type: 'error',
                  message: res.errorMessage
                })
              }
            }, function () {
              that.$message({
                type: 'error',
                message: '入驻失败'
              })
            })
          }).catch(() => {
          })
        },
        getSpaseTypeList () {
          var _this = this
          $axios.get('/device/getDeviceIndustry', null, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.$store.state.spaceDataList = res.resultData.list
              _this.spaceTypeList = _this.$store.state.spaceDataList
              _this.queryDeviceList(_this.pageNo, _this.pageSize, '')
            }
          })
        },
        queryDeviceList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            isAssigned: 1,
            online: this.onlineDevice
          }
          this.table_loading = true
          this.deviceData = []
          $axios.get('/device/getDeviceList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var mType = '---'
                  if (itemData.user_type === 0) {
                    mType = '超级管理员'
                  } else if (itemData.user_type === 1) {
                    mType = '代理商'
                  } else if (itemData.user_type === 2) {
                    mType = '设备主'
                  } else if (itemData.user_type === 3) {
                    mType = '维护人员'
                  } else if (itemData.user_type === 4) {
                    mType = '商户'
                  } else if (itemData.user_type === 5) {
                    mType = '销售'
                  }

                  var extendInfoItem = {}
                  //console.log("item1="+itemData.devicePoint.extendInfo)
                  if (!isNull(itemData.devicePoint.extendInfo)&&itemData.devicePoint.extendInfo.indexOf('{')>-1){
                    extendInfoItem = JSON.parse(itemData.devicePoint.extendInfo)
                  }


                  var item = {
                    num: itemData.deviceCode,
                    uuid: itemData.uuid,
                    id: itemData.id,
                    name: itemData.alias,
                    owner: itemData.nickName,
                    payStatus: isNull(itemData.devicePoint) ? '无' : itemData.devicePoint.status,
                    payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                    payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                    spase: _this.getDeviceSpaceValue(_this.spaceTypeList, itemData.ownerType),
                    address: itemData.address,
                    status: itemData.isOnline === 0 ? '离线' : '在线',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume,
                    user_type: mType,
                    laneInfoStr: itemData.laneInfoStr,
                    extendInfo:extendInfoItem,
                    badTxt:_this.getBadStatus(itemData.isBad)
                  }

// console.log("bad="+_this.getBadStatus(itemData.isBad))
                  //console.log("item="+JSON.stringify(item))
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },
        queryDeviceListByKey (tType, tKeyWord, tPageNo, tPageSize) {
          var _this = this
          var params = {
            type: tType,
            keyword: tKeyWord,
            pageNo: tPageNo,
            pageSize: tPageSize,
            isAssigned: 1
          }
          this.table_loading = true
          this.deviceData = []
          $axios.get('/device/query', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var mType = '---'
                  if (itemData.user_type === 0) {
                    mType = '超级管理员'
                  } else if (itemData.user_type === 1) {
                    mType = '代理商'
                  } else if (itemData.user_type === 2) {
                    mType = '设备主'
                  } else if (itemData.user_type === 3) {
                    mType = '维护人员'
                  } else if (itemData.user_type === 4) {
                    mType = '商户'
                  } else if (itemData.user_type === 5) {
                    mType = '销售'
                  }

                  var extendInfoItem = {}
                  //console.log("item1="+itemData.devicePoint.extendInfo)
                  if (!isNull(itemData.devicePoint.extendInfo)&&itemData.devicePoint.extendInfo.indexOf('{')>-1){
                    extendInfoItem = JSON.parse(itemData.devicePoint.extendInfo)
                  }

                  var item = {
                    num: itemData.deviceCode,
                    uuid: itemData.uuid,
                    id: itemData.id,
                    name: itemData.alias,
                    owner: itemData.nickName,
                    payStatus: isNull(itemData.devicePoint) ? '无' : itemData.devicePoint.status,
                    payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                    payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                    spase: _this.getDeviceSpaceValue(_this.spaceTypeList, itemData.ownerType),
                    address: itemData.address,
                    status: itemData.isOnline === 0 ? '离线' : '在线',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume,
                    user_type: mType,
                    laneInfoStr: itemData.laneInfoStr,
                    extendInfo:extendInfoItem,
                    badTxt:_this.getBadStatus(itemData.isBad)
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },
        popUpdateDeviceCargoLane (uuid,status) {
            var that = this
            var params = {
              uuid: uuid,
              status: status
            }
            that.$confirm('是否切换单/双货道？如选择不正确，可能导致无法出货', '确认切换', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              $axios.get('/device/setCargoLane', params, 'headers', function (res) {
                if (res && res.resultStatus === true) {
                  that.$message({
                    type: 'success',
                    message: '切换成功!'
                  })
                  that.queryDeviceList()
                } else {
                  that.$message({
                    type: 'error',
                    message: '切换失败!'
                  })
                }
              }, function () {
                that.$message({
                  type: 'error',
                  message: '切换失败!'
                })
              })
            }).catch(() => {
              that.$message({
                type: 'info',
                message: '已取消'
              })
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        confirmRemove () {
          var that = this
          if (that.multipleSelection.length === 0) {
            that.$alert('请选择要回收的资源', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return false
          }
          that.$confirm('您已选择设备：' + that.multipleSelection, '是否回收选中的设备', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var params = {
              deviceId: that.deviceId
            }
            $axios.get('/device/recoveryDevice', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.queryDeviceList(that.pageNo, that.pageSize, '')
                that.$message({
                  type: 'success',
                  message: '回收设备成功!'
                })
              } else {
                that.$message({
                  type: 'error',
                  message: '回收设备失败'
                })
              }
            }, function () {
              that.$message({
                type: 'error',
                message: '回收设备失败'
              })
            })
          }).catch(() => {
          })
        },
        allotDevice () {
          var that = this
          if (that.multipleSelection.length === 0) {
            that.$message({
              type: 'warning',
              duration: 1000 * 5,
              message: '请选择要分配的设备!'
            })
            return false
          }
          that.allotDeviceShow = true
          that.show = true
        },
        closeAllot () {
          this.show = false
          this.allotDeviceShow = false
          this.queryDeviceList(this.pageNo, this.pageSize, '')
        },
        selectSeeItem (command) {
          if (command === 'ad') {
            this.$message('click on itme ' + '广告')
          } else if (command === 'weixin') {
            this.$message('click on itme ' + '公众号')
          } else if (command === 'record') {
            this.$message('click on itme ' + '补货记录')
          } else if (command === 'details') {
            this.$message('click on itme ' + '设备详情')
          }
        },
        openAllotRightPop (value) {
          if (this.deviceSelect.length > 0) {
            this.allotShow = true
            this.allotType = value
            this.allotPopRightOk = true
          } else {
            var val = (value === 'pic' ? '广告' : (value === 'picFirst' ? '上分屏广告' : (value === 'wx' ? '公众号' : (value === 'video' ? '视频' : (value === 'sale' ? '销售'
            : (value === 'picFu' ? '副屏广告' : ( value === 'bussiness' ? '商户' : '运营')))))))
            this.$message({
              type: 'warning',
              duration: 1000 * 5,
              message: '请选择要分配' + val + '的设备!'
            })
          }
        },
        popEditP (code, status, po, pr, extendInfo, bGetUserInfo) {
          this.deviceCode = code
          this.eStatus = status
          this.ePoints = po
          this.ePrice = pr
          this.myEditPopShow = true
          this.extendInfo = extendInfo
          this.bGetUserInfo = bGetUserInfo
          console.log("extendInfo="+JSON.stringify(extendInfo))
        },
        popEditParam (code) {
          this.deviceCode = code
          this.myEditPopShowParam = true
        },
        popEditPrice (code, pr) {
          this.deviceCode = code
          this.ePrice = pr
          this.myEditPriceShow = true
        },
        closeEditP () {
          this.myEditPopShow = false
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        closeEditParam () {
          this.myEditPopShowParam = false
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        closeEditPrice () {
          this.myEditPriceShow = false
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        closeAllotRightPop (value) {
          this.allotPopRightOk = false
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        deviceSelectionChange (val) {
          this.deviceSelect = val
          this.multipleSelection = ''
          this.deviceId = ''
          for (var i = 0; i < val.length; i++) {
            this.multipleSelection += (val[i].num + '|')
            this.deviceId += (val[i].id + '|')
          }
        },
        getDeviceSpaceValue (items, index) {
          var returnData
          if (isNull(index) || isNull(items)) {
            returnData = '无'
          } else {
            for (var i = 0; i < items.length; i++) {
              if (index === items[i].id) {
                returnData = items[i].name
              }
            }
          }
          return returnData
        },
        seeNext (mSeeType, mDeviceCoe, uuid) {
          this.uuid = uuid
          this.deviceCode = mDeviceCoe
          this.seeType = mSeeType
          this.seePopRightOk = true
          this.seeShow = true
        },
        closeSeeRightPop () {
          this.seePopRightOk = false
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        queryDevicByKeyword () {
          this.pageNo = 1
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        payStatusDes (num) {
          var payStatusDesValue = [{
            key: 0,
            value: '文章标准'
          }, {
            key: 1,
            value: '文章纯积分(已停止使用)'
          }, {
            key: 2,
            value: '支付页购买(已停止使用)'
          }, {
            key: 3,
            value: '承德888'
          }, {
            key: 4,
            value: '支付无页面(已停止使用)'
          }, {
            key: 5,
            value: '长按标准(已停止使用)'
          }, {
            key: 6,
            value: '纯支付--支持支付宝和微信'
          }, {
            key: 7,
            value: '长按每天一包(已停止使用)'
          }, {
            key: 8,
            value: '每天长按一包'
          }, {
            key: 9,
            value: '每天多包,长按,可以左右滑动(停止使用)'
          }, {
            key: 10,
            value: '每天多包,长按,可以左右滑动,有再来一次按钮'
          }, {
            key: 13,
            value: '每天免费一包，再次收费'
          }, {
            key: 1001,
            value: '嘉兴的流程(定制的流程)'
          }]
          var returnData
          if (num === '无') {
            returnData = '未知流程'
          } else {
            returnData = '未知流程'
            for (var i = 0; i < payStatusDesValue.length; i++) {
              if (num === payStatusDesValue[i].key) {
                returnData = payStatusDesValue[i].value
              }
            }
          }
          return returnData
        },
        changePlatformStatus (val) {
          var that = this
          var status = val ? 1 : 0
          var params = {
            deviceCode: '0',
            status: status
          }
          $axios.post('/deviceAd/updateAcceptAdStatus', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              that.queryDeviceList(that.pageNo, that.pageSize, '')
              if (val === 1) {
                that.$message({
                  type: 'success',
                  message: '已可以接收广告平台的广告'
                })
              } else {
                that.$message({
                  type: 'error',
                  message: '不可以接收广告平台的广告'
                })
              }
            } else {
              that.$message({
                type: 'error',
                message: '修改状态失败'
              })
            }
          }, function () {
            that.$message({
              type: 'error',
              message: '修改状态失败'
            })
          })
        }
      },
      components: {
        'pu-allot-pop-right': puAllotPopRight,
        'pu-see-pop-right': puSeePopRight,
        'pu-edit-pop': puEditPop,
        'pu-edit-pop-param': puEditPopParam,
        'pu-edit-price': puEditPrice,
        'po-allot-device': poAllotDevice
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
    .deviceBind {
        .el-select .el-input {
          width: 110px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/deviceBind.vue